<template>
    <div class="header">
        <div class="nav">
            <div class="logo">
                <router-link to="/"></router-link>
            </div>
            <div class="menu" @click="openMenu"></div>
        </div>
        <hr>
        <div class="menuCon" v-if="menuShow">
            <div class="listBox">
                <router-link to="/">
                    <div class="home" @click="openMenu">HOME</div>
                    <div class="menuHr"></div>
                </router-link>
                <router-link to="/article">
                    <div class="article" @click="openMenu">ARTICLE</div>
                    <div class="menuHr"></div>
                </router-link>
                <!-- <router-link to="/allMagezine">
                    <div class="magezine" @click="openMenu">MAGAZINE</div>
                    <div class="menuHr"></div>
                </router-link> -->
                <!-- <router-link to="/activity">
                    <div class="stepInto" @click="openMenu">STEP INTO</div>
                    <div class="menuHr"></div>
                </router-link> -->
                <router-link to="/aboutus">
                    <div class="aboutUs" @click="openMenu">ABOUT & CONTACT US</div>
                    <div class="menuHr"></div>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Header',
    data(){
        return{
            menuShow:false
        }
    },
    methods:{
        openMenu(){
            this.menuShow = !this.menuShow
        }
    }
}
</script>
<style scoped>
html,body{
    padding: 0;
    margin: 0;
}
.header{
    width: 100vw;
    height: fit-content;
    background-color: #000;
}
::-webkit-scrollbar {
  display: none;
}
a {
    color: #fff;
    text-decoration: none;
}
.router-link-active {
    color: #fff;
    text-decoration: none;
}
.header .nav{
    width: 100vw;
    height: 50px;
    line-height: 50px;
    background: #000;
    color: #fff;
    position: fixed;
    z-index: 10;
    top: 0;
    display: inline-block;
}
.header .nav .logo{
    width: 120px;
    height: 50px;
    float: left;
    background: transparent url('../assets/steppy.png') 10px center no-repeat;
    background-size: 70%;
}
.header .nav .menu{
    width: 50px;
    height: 50px;
    float: right;
    background: transparent url('../assets/menu_steppy.png') center no-repeat;
    background-size: 50%;
}
hr {
  width: calc(100vw - 20px);
  border: none;
  height: 1px;
  background: #888;
  position: fixed;
  z-index: 10;
  top: 50px;
  margin: 0 10px;
}
.header .menuHr{
  width: calc(100vw - 10px);
  border: none;
  height: 1px;
  background: #888;
  margin: 5px;
}
.header .menuCon{
    width: 100vw;
    height: calc(100vh - 51px);
    background: #000;
    color: #fff;
    position: fixed;
    top: 51px;
    z-index: 10;
}
.header .menuCon .listBox {
  width: 100vw;
  height: fit-content;
  text-align: right;
  font-size: 24px;
  position: absolute;
  top: 20px;
}
.header .menuCon .listBox .home, .article, .magezine, .stepInto, .aboutUs, .contactUs{
  width: 100vw;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.header .menuCon .listBox .home::after, .article::after, .magezine::after, .stepInto::after, .aboutUs::after, .contactUs::after{
    content: url('../assets/enterIcon.png');
    width: 30px;
    height: 30px;
    transform: scale(0.8);
}
</style>


// WEBPACK FOOTER //
// src/components/Header_M.vue